import { ParseErrorTypes } from '@nimbus-library/features/graph/enums/parser-error-types.enum';
import { SearchOptions } from '@nimbus-library/features/graph/enums/search-options.enum';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
export type SearchExpressionQueryIds = { [key in SearchOptions]?: string };
export type SearchExpressionErrorMessages = { [key in ParseErrorTypes]?: { translationKey: TranslationKeys; concat: boolean } };

export const userSearchQueryFactories: SearchExpressionQueryIds = {
  city: 'city',
  country: 'country',
  department: 'department',
  jobTitle: 'jobTitle',
  location: 'officeLocation',
  postalCode: 'postalCode',
  state: 'state',
  streetAddress: 'streetAddress',
  accountEnabled: 'accountEnabled',
};

export const contactSearchQueryFactories: SearchExpressionQueryIds = {
  ...userSearchQueryFactories,
  assistant: 'assistantName',
  manager: 'manager',
  company: 'companyName',
};

export const defaultParseErrorMessages: SearchExpressionErrorMessages = {
  expression: { translationKey: TranslationKeys.SearchParserExpressionError, concat: true },
  value: { translationKey: TranslationKeys.SearchParserValueError, concat: true },
  spacing: { translationKey: TranslationKeys.SearchParserSpacingErrorGeneral, concat: false },
  duplicates: { translationKey: TranslationKeys.SearchParserDuplicatesError, concat: true },
};
